import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=3bc281f2&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=3bc281f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc281f2",
  null
  
)

export default component.exports